// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__Zjc60","color":"Nav_color__f1OLO"};